import { render, staticRenderFns } from "./RealmManagement.vue?vue&type=template&id=0e735b6c&scoped=true&"
import script from "./RealmManagement.vue?vue&type=script&lang=js&"
export * from "./RealmManagement.vue?vue&type=script&lang=js&"
import style0 from "./RealmManagement.vue?vue&type=style&index=0&id=0e735b6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e735b6c",
  null
  
)

export default component.exports